import { gql } from '@apollo/client';

const revokeMcpKey = gql`
  mutation RevokeMcpKey($id: ID!) {
    revokeMcpKey(id: $id)
  }
`;

export default revokeMcpKey;
